import React, { useEffect, useState } from 'react';
import { fetchProfileAvatarUrl } from '../api/profiles';
import './Avatar.css';

// First letter of the first word + first letter of the last word, uppercased. A single-word name
// (or empty) just uses what it has — never throws on ''/null.
export function getInitials(name) {
  const words = String(name || '').trim().split(/\s+/).filter(Boolean);
  if (words.length === 0) return '';
  const first = words[0][0];
  const last = words.length > 1 ? words[words.length - 1][0] : '';
  return (first + last).toUpperCase();
}

// Real photo if the profile has one on file, else a colored initials circle. Mirrors the codebase's
// existing blob-URL convention (api/portal.js's fetchDashboardDocumentPreviewUrl) — GET
// /profiles/:id/avatar requires the bearer token, so a plain <img src="..."> can't load it directly.
// `avatarPath` is only ever used as a truthy/change signal here (the actual bytes always come from
// the authenticated fetch) — pass profiles.ts's raw avatarPath field straight through.
export default function Avatar({ profileId, avatarPath, name, size = 32 }) {
  const [objectUrl, setObjectUrl] = useState(null);

  useEffect(() => {
    if (!profileId || !avatarPath) { setObjectUrl(null); return undefined; }
    let cancelled = false;
    let url = null;
    fetchProfileAvatarUrl(profileId).then((u) => {
      if (cancelled) { URL.revokeObjectURL(u); return; }
      url = u;
      setObjectUrl(u);
    }).catch(() => { if (!cancelled) setObjectUrl(null); });
    return () => {
      cancelled = true;
      if (url) URL.revokeObjectURL(url);
    };
  }, [profileId, avatarPath]);

  const dim = `${size}px`;
  if (objectUrl) {
    return <img src={objectUrl} alt="" className="avatar-img" style={{ width: dim, height: dim }} />;
  }
  return (
    <span className="avatar-initials" style={{ width: dim, height: dim, fontSize: `${Math.round(size * 0.42)}px` }}>
      {getInitials(name)}
    </span>
  );
}
